export function initTableOfContents() {
	const tocContainer = document.getElementById("table-of-contents-placeholder");
	if (!tocContainer) return;

	const nav = document.createElement("nav");
	nav.id = "table-of-contents";
	const h2 = document.createElement("h2");
	h2.textContent = "Sommaire";
	const ul = document.createElement("ul");
	nav.appendChild(h2);
	nav.appendChild(ul);

	document.querySelectorAll("h2").forEach((heading, idx) => {
		let id = heading.getAttribute("id");
		if (!id) {
			id = "section" + (idx + 1);
			heading.setAttribute("id", id);
		}
		const li = document.createElement("li");
		const a = document.createElement("a");
		a.href = "#" + id;
		a.textContent = heading.textContent;
		li.appendChild(a);
		ul.appendChild(li);
	});

	tocContainer.replaceWith(nav);
}
